<template>
  <v-container fluid class="px-0 py-0">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
        @embedded_action="embeddedAction($event)"
    >
      <template v-slot:body="{height}">
        <v-sheet class="pt-3 px-3" v-if="!!currentItem">
          <v-row dense>
            <v-col cols="3">
              <CommonFieldString
                  v-model="currentItem.name"
                  :label="$t('name')"
              ></CommonFieldString>
            </v-col>
            <v-col cols="1">
              <CommonFieldNumber
                  v-model.number="currentItem.batch_size"
                  :label="$t('batch_size')"
              >
              </CommonFieldNumber>
            </v-col>
            <v-col cols="3">
              <CommonPartialSelectFromTable
                  v-model="currentItem.product_uid"
                  dto-list-query="ProductListQueryDTO"
                  :sort-by="['name']"
                  :query-filters="queryProductFilters"
              >
              </CommonPartialSelectFromTable>
            </v-col>
            <v-col cols="1">
              <CommonFieldString
                  v-model="product_article_number"
                  :label="$t('product_article_number')"
                  outlined
                  readonly
                  class="mr-3"
                  :append-icon="!!product_article_number ? '' : 'mdi-alert-outline'"
              >
              </CommonFieldString>
            </v-col>
            <v-col cols="1">
              <CommonFieldString
                  v-model="customer_name"
                  :label="$t('customer')"
                  outlined
                  readonly
                  class="mr-3"
                  :append-icon="!!customer_name ? '' : 'mdi-alert-outline'"
              >
              </CommonFieldString>
            </v-col>
            <v-col cols="2">
              <CommonPartialSelectFromTable
                  v-model="currentItem.customer_order_uid"
                  dto-list-query="CustomerOrderListQueryDTO"
                  :sort-by="['name']"
                  :query-filters="queryCustomerOrderFilters"
              >
              </CommonPartialSelectFromTable>
            </v-col>
          </v-row>
          <v-tabs class="mt-n6" v-if="!!currentItem">
            <v-tab>Import&Match</v-tab>
            <v-tab-item>
              <CoreBomSheetTable
                  title=""
                  dto-list-query="BomSheetMatchListQueryDTO"
                  :store-name="storeBomSheetMatchTableName"
                  :height="height - 260"
                  :headers="bomSheetMatchHeaders"
                  :detail-store-name="storeBomSheetDetailName"
                  :hide-default-footer="true"
                  :hide-default-header="true"
                  :show-select="true"
                  :main-validator="false"
                  :row-background="rowBackgroundMatch"
              ></CoreBomSheetTable>
            </v-tab-item>
            <v-tab>Panasonic</v-tab>
            <v-tab-item>
              <CoreBomSheetTable
                  title=""
                  dto-list-query="BomSheetPanasonicListQueryDTO"
                  :store-name="storeBomSheetPanasonicTableName"
                  :height="height - 260"
                  :headers="bomSheetPanasonicHeaders"
                  :hide-default-footer="true"
                  :hide-default-header="true"
                  :show-select="true"
                  :main-validator="false"
                  :row-background="rowBackgroundPanasonic"
              ></CoreBomSheetTable>
            </v-tab-item>
            <v-tab>Pick & Place</v-tab>
            <v-tab-item>
              <CorePickPlaceSheetTable
                  title=""
                  dto-list-query="PickPlaceSheetListQueryDTO"
                  :store-name="storePickPlaceSheetTableName"
                  :height="height - 260"
                  :detail-store-name="storePickPlaceSheetDetailName"
                  :hide-default-footer="true"
                  :hide-default-header="true"
                  :show-select="true"
                  :main-validator="false"
              ></CorePickPlaceSheetTable>
            </v-tab-item>
            <v-tab>BOM-DGS Compare</v-tab>
            <v-tab-item>
              <CommonHTMXComponent :iframe-src="'/component/bom_dgs_compare/' + storeUidItem + '/'" :height="height - 260"></CommonHTMXComponent>
            </v-tab-item>
          </v-tabs>
        </v-sheet>
      </template>
    </CommonDetail>
    <v-dialog
        v-model="dialogImportTable"
    >
      <CoreBomImportTable
          @cancel="onImportClose()"
          @import="importTable($event)"
      >
      </CoreBomImportTable>
    </v-dialog>
    <v-dialog
        v-model="dialogImportPickPlaceTable"
    >
      <CoreImportPickPlaceTable
          @cancel="onImportPickPlaceClose()"
          @import="importPickPlaceTable($event)"
      >
      </CoreImportPickPlaceTable>
    </v-dialog>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import BaseFieldString from "@/components/Base/BaseFieldString";
import CommonFieldString from "@/components/Common/CommonFieldString";
import CommonFieldNumber from "@/components/Common/CommonFieldNumber";
import CoreBomSheetTable from "@/components/CoreComponent/BomSheet/CoreBomSheetTable";
import {useTableStore} from "@/components/Common/CommonTable";
import CoreBomImportTable from "@/components/CoreComponent/Bom/CoreBomImportTable";
import CorePickPlaceSheetTable from "@/components/CoreComponent/PickPlaceSheet/CorePickPlaceSheetTable";
import CoreImportPickPlaceTable from "@/components/CoreComponent/PickPlace/CoreImportPickPlaceTable";
import CommonPartialSelectFromTable from "@/components/Common/CommonPartialSelectFromTable";
import CommonHTMXComponent from "@/components/Common/CommonHTMXComponent.vue";

export default {
  name: "CoreBomDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'CoreBomDetail'},
    dtoDetailQuery: {default: 'BomDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'BomActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'BomSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'BomValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'BomDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'CoreBomTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    CommonHTMXComponent,
    CoreBomSheetTable,
    BaseFieldString,
    CommonDetail,
    CommonFieldString,
    CommonFieldNumber,
    CoreBomImportTable,
    CorePickPlaceSheetTable,
    CoreImportPickPlaceTable,
    CommonPartialSelectFromTable,
  },

  computed: {
    currentItem() {
      if (!!this.storeAggregate && !!this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
    storeUidItem() {
      if (!!this.storeDetail)
        return this.storeDetail.uidItem
      else
        return null
    },
    product_uid() {
      if (!!this.currentItem && !!this.currentItem.product_uid)
        return this.currentItem.product_uid
      return null
    },
    product_article_number() {
      if (!!this.product_uid)
        return this.storeAggregate.rootData[this.product_uid].article_number
      else
        return null
    },
    customer_uid() {
      if (!!this.product_uid &&
          !!this.storeAggregate.rootData[this.product_uid] &&
          !!this.storeAggregate.rootData[this.storeAggregate.rootData[this.product_uid].project_customer_uid])
        return this.storeAggregate.rootData[this.storeAggregate.rootData[this.product_uid].project_customer_uid].customer_uid
      return null
    },
    customer_name() {
      if (!!this.customer_uid)
        return this.storeAggregate.rootData[this.customer_uid].name
      else
        return null
    },
  },

  watch: {
    storeUidItem: {
      handler(newValue, oldValue) {
        // console.log('watch BomDetail uidItem', newValue, oldValue)
        this.filterBomSheetTable()
        this.storeBomSheetDetail.parentUid = this.storeDetail.uidItem
        this.storePickPlaceSheetDetail.parentUid = this.storeDetail.uidItem
      },
      deep: true
    },
  },

  methods: {
    rowBackgroundMatch(item) {
      if (item.import_error_status === 'ERROR')
        return 'red lighten-4'
      if (item.import_error_status === 'WARNING')
        return 'orange lighten-4'
      if (item.import_error_status === 'SUCCESS')
        return 'green lighten-4'
    },
    rowBackgroundPanasonic(item) {
      if (item.panasonic_error_status === 'ERROR')
        return 'red lighten-4'
      if (item.panasonic_error_status === 'WARNING')
        return 'orange lighten-4'
      if (item.panasonic_error_status === 'SUCCESS')
        return 'green lighten-4'
    },
    filterBomSheetTable() {
      this.storeBomSheetMatchTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'bom__uid', value: this.storeUidItem, enable: true},
        ],
        enable: true,
      }
      this.storeBomSheetPanasonicTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'bom__uid', value: this.storeUidItem, enable: true},
        ],
        enable: true,
      }
      this.storePickPlaceSheetTable.query_filters = {
        and_concat: true,
        filter_list: [
          {
            param_compare: 'pick_place__bom__uid',
            value: this.storeUidItem,
            enable: true
          },
        ],
        enable: true,
      }
    },
    embeddedAction(event) {
      // console.log('embeddedAction', event)
      if (event.actionName === 'embedded_import_bom') {
        this.dialogImportTable = true
        return
      }
      if (event.actionName === 'embedded_import_pick_place') {
        this.dialogImportPickPlaceTable = true
        return
      }
    },
    onImportClose() {
      // console.log('onImportClose', event)
      this.dialogImportTable = false
    },
    importTable(selectedItems) {
      console.log('importTable', selectedItems)
      let data = {
        selected_items: selectedItems,
      }
      this.storeDetail.onAction({actionName: 'import_bom_sheet', actionUid: null, data: data})
      this.dialogImportTable = false
    },
    onImportPickPlaceClose() {
      // console.log('onImportClose', event)
      this.dialogImportPickPlaceTable = false
    },
    importPickPlaceTable(selectedItems) {
      // console.log('importPickPlaceTable', selectedItems, editedItem)
      let data = {
        selected_items: selectedItems,
      }
      this.storeDetail.onAction({actionName: 'import_pick_place', actionUid: null, data: data})
      this.dialogImportPickPlaceTable = false
    },
  }
  ,

  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
    this.storeBomSheetMatchTable = useTableStore(this.storeBomSheetMatchTableName)()
    this.storeBomSheetMatchTable.dtoListQuery = 'BomSheetMatchListQueryDTO'
    this.storeBomSheetMatchTable.options.itemsPerPage = -1
    this.storeBomSheetMatchTable.options.sortBy = ['order']
    this.storeBomSheetMatchTable.options.sortDesc = [true]
    this.storeBomSheetMatchTable.footerProps = {'items-per-page-options': [5, 20, 50, 100, 200, -1]}

    this.storeBomSheetPanasonicTable = useTableStore(this.storeBomSheetPanasonicTableName)()
    this.storeBomSheetPanasonicTable.dtoListQuery = 'BomSheetPanasonicListQueryDTO'
    this.storeBomSheetPanasonicTable.options.itemsPerPage = -1
    this.storeBomSheetPanasonicTable.options.sortBy = ['order']
    this.storeBomSheetPanasonicTable.options.sortDesc = [true]
    this.storeBomSheetPanasonicTable.footerProps = {'items-per-page-options': [5, 20, 50, 100, 200, -1]}

    this.storePickPlaceSheetTable = useTableStore(this.storePickPlaceSheetTableName)()
    this.storePickPlaceSheetTable.dtoListQuery = 'PickPlaceSheetListQueryDTO'
    this.storePickPlaceSheetTable.options.itemsPerPage = -1
    this.storePickPlaceSheetTable.options.sortBy = ['designator']
    this.storePickPlaceSheetTable.options.sortDesc = [true]
    this.storePickPlaceSheetTable.footerProps = {'items-per-page-options': [5, 20, 50, 100, 200, -1]}

    this.storeBomSheetDetail = useDetailStore(this.storeBomSheetDetailName)()
    this.storePickPlaceSheetDetail = useDetailStore(this.storePickPlaceSheetDetailName)()

    this.filterBomSheetTable()
  }
  ,

  data() {
    return {
      currentTab: 0,
      dialogImportTable: false,
      dialogImportPickPlaceTable: false,
      storeDetail: null,
      storeAggregate: null,
      storeBomSheetMatchTable: null,
      storeBomSheetMatchTableName: uuidv4(),
      storeBomSheetPanasonicTable: null,
      storeBomSheetPanasonicTableName: uuidv4(),
      storePickPlaceSheetTable: null,
      storePickPlaceSheetTableName: uuidv4(),
      storeBomSheetDetail: null,
      storeBomSheetDetailName: uuidv4(),
      storePickPlaceSheetDetail: null,
      storePickPlaceSheetDetailName: uuidv4(),
      bomSheetMatchHeaders: [
        {text: '', value: 'order', sortable: true, filterable: true, divider: true, width: 10, type: 'drag'},
        {
          text: 'Status',
          value: 'row_match_statuses',
          sortable: false,
          filterable: true,
          divider: true,
          align: 'center',
          width: 10,
          type: 'status'
        },
        {text: 'Task', value: 'task_dto', sortable: false, filterable: true, divider: true, width: 10},
        {text: 'Edit', value: 'edit', sortable: false, filterable: true, divider: true, width: 10},
        // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
        {text: 'Do not place', value: 'do_not_place', sortable: false, filterable: true, divider: true, type: 'bool', align: 'center', width: 10, color: 'green'},
        {
          text: 'Provided by customer',
          value: 'provided_by_customer',
          sortable: false,
          filterable: true,
          divider: true,
          type: 'bool',
          align: 'center',
          width: 10,
          color: 'green'
        },
        {text: 'QTY', value: 'qty', sortable: true, filterable: true, divider: true, align: 'right', width: 60},
        {text: 'Designator', value: 'designator', sortable: true, align: 'center', divider: true, width: 150, type: 'text'},
        {text: 'Description', value: 'description', sortable: false, divider: true, width: 150, type: 'text'},
        {text: 'MPN', value: 'mpn', sortable: false, align: 'center', divider: true, width: 150},
        {text: 'Original article', value: 'article', sortable: false, align: 'right', divider: true, width: 50},
        {text: 'Customer article', value: 'customer_article', sortable: false, align: 'left', divider: true, width: 50},
        // {text: '', value: 'component_search', sortable: false, align: 'center', divider: true, width: 80},
        {text: 'Article', value: 'component__article', sortable: true, align: 'end', divider: true, width: 70},
        {text: 'Alias', value: 'component__alias', sortable: true, align: 'right', divider: true, width: 210},
        {
          text: 'Type',
          value: 'component__case_package__type',
          sortable: false,
          align: 'center',
          divider: true,
          width: 70
        },
        {
          text: 'Category',
          value: 'component__subcategory__category__category',
          sortable: false,
          align: 'center',
          divider: true,
          width: 100
        },
        {
          text: 'Case Package',
          value: 'component__case_package__name',
          sortable: false,
          align: 'center',
          divider: true,
          width: 80
        },
        {text: 'Image', value: 'component__image', sortable: false, align: 'center', divider: true, width: 60},
        {
          text: 'Datasheet',
          value: 'component__datasheet',
          sortable: false,
          align: 'center',
          divider: true,
          width: 20,
          type: 'link'
        },

        // {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
        // {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
        // {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
        // {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
        {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
      ],
      bomSheetPanasonicHeaders: [
        // {text: 'T', value: 'task_dto', sortable: false, filterable: true, divider: true, width: 25},
        // {text: '', value: 'order', sortable: true, filterable: true, divider: true, width: 25, type: 'drag'},
        {
          text: 'Status',
          value: 'row_panasonic_statuses',
          sortable: false,
          filterable: true,
          divider: true,
          align: 'center',
          width: 10,
          type: 'status'
        },
        {text: 'Edit', value: 'edit', sortable: false, filterable: true, divider: true, width: 10},
        // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
        {text: 'Do not place', value: 'do_not_place', sortable: false, filterable: true, divider: true, type: 'bool', align: 'center', width: 10, color: 'green'},
        {
          text: 'Provided by customer',
          value: 'provided_by_customer',
          sortable: false,
          filterable: true,
          divider: true,
          type: 'bool',
          align: 'center',
          width: 10,
          color: 'green'
        },
        {text: 'QTY', value: 'qty', sortable: true, filterable: true, divider: true, align: 'right', width: 60},
        {
          text: 'QTY P&P',
          value: 'quantity_pick_place',
          sortable: true,
          filterable: true,
          divider: true,
          align: 'right',
          width: 60
        },
        {text: 'Designator', value: 'designator', sortable: true, align: 'center', divider: true, width: 150, type: 'text'},
        // {text: 'Description', value: 'description', sortable: false, divider: true, width: 200},
        // {text: 'MPN', value: 'mpn', sortable: false, align: 'center', divider: true,},
        // {text: 'Original article', value: 'article', sortable: false, align: 'right', divider: true, width: 50},
        // {text: 'Customer article', value: 'customer_article', sortable: false, align: 'left', divider: true, width: 50},
        // {text: '', value: 'component_search', sortable: false, align: 'center', divider: true, width: 80},
        {text: 'Article', value: 'component__article', sortable: true, align: 'end', divider: true, width: 70},
        {text: 'Alias', value: 'component__alias', sortable: true, align: 'right', divider: true, width: 210},
        // {text: 'MPN', value: 'component_mpn', sortable: false, align: 'left', divider: true, width: 200},
        {
          text: 'Type',
          value: 'component__case_package__type',
          sortable: false,
          align: 'center',
          divider: true,
          width: 70
        },
        {text: 'Layers', value: 'layers', sortable: false, align: 'center', divider: true, width: 70},
        {
          text: 'Category',
          value: 'component__subcategory__category__category',
          sortable: false,
          align: 'center',
          divider: true,
          width: 100
        },
        {
          text: 'Case Package',
          value: 'component__case_package__name',
          sortable: false,
          align: 'center',
          divider: true,
          width: 80
        },
        {text: 'Image', value: 'component__image', sortable: false, align: 'center', divider: true, width: 60},
        {
          text: 'Datasheet',
          value: 'component__datasheet',
          sortable: false,
          align: 'center',
          divider: true,
          width: 20,
          type: 'link'
        },

        // {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
        // {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
        // {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
        // {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
        {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
      ],
      queryProductFilters: {
        and_concat: true,
        filter_list: [
          {param_compare: 'name__isnull', value: false,},
          {param_compare: 'name', value: '', negative: true},
        ],
        enable: true,
      },
      queryCustomerOrderFilters: {
        and_concat: true,
        filter_list: [
          {param_compare: 'name__isnull', value: false,},
          {param_compare: 'name', value: '', negative: true},
        ],
        enable: true,
      },
    }
  }
  ,
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>